import React, { FunctionComponent } from "react";

import { FrameAttributeSharedProps } from "../../types";
import { LiteListFrameGeneralAttribute } from "../LiteListFrameGeneralAttribute";
import { LiteListFrameLinkAttributeComponent } from "../LiteListFrameLinkAttributeComponent";

export type LiteListFrameLinkAttributeProps = FrameAttributeSharedProps;
/** Komponenta, sloužící k vykreslení hodnoty atributu jako text nebo odkaz v lite list framu. */
export const LiteListFrameLinkAttribute: FunctionComponent<LiteListFrameLinkAttributeProps> = (
    props,
) => (
    <LiteListFrameGeneralAttribute
        {...props}
        AttributeComponent={LiteListFrameLinkAttributeComponent}
    />
);
